import React, {useState, useEffect, useRef} from "react";
import { FaTimes as FaClose, FaFilter, FaTimes, FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import server from '../../../api/server';
import '../../../dashboard-components/loader.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigateWithCurrentQuery } from '../../../utils/routerUtils';
import CustomerDetails from "./CustomerDetails"
import ModernTimeDropdown from "../../../dashboard-components/layouts/modernDropdown";
import ModernDatePicker from "../../../dashboard-components/layouts/ModernDatePicker";
import { useToast } from '../../../context/ToastContext';
import { Download } from 'lucide-react';
import VoiceCustomerDownloadParametersModal from './VoiceCustomerDownloadParametersModal.jsx';
import { buildVoiceAgentCustomersDownloadBody } from '../../../utils/voiceAgentDownloadPayload.js';
import { FaCaretDown, FaCaretRight } from "react-icons/fa6";
import { initializeFiltersFromUrl, updateUrlWithFilters, getListPageFromLocation } from '../../../utils/filterUtils';

const CustomerRecords = ({serviceID, clientID, segment, type}) => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  // Default filter values
  const defaultFilters = {
    agent: '',
    firstinteraction: '',
    lastinteraction: 'Last 7 Days',
    customer_id: '',
    'First Interaction Start': '',
    'First Interaction End': '',
    'Last Interaction Start': '',
    'Last Interaction End': ''
  };

  const defaultAdvancedFilters = {
    refusalCategory: '',
    customerPotential: "",
    customer_outcome: '',
    openConcerns: '',
    id: '',
    interactions: '',
    concernCategory: '',
    concernSubcategory: '',
    queryCategory: '',
    querySubcategory: '',
    business_insights_multiple: [],
    disposition: '',
    subdisposition: '',
    lead_source: '',
    tag: ''
  };

  // Initialize filters from URL or use defaults (only when not passed via segment prop)
  const initialFilterState = !segment ? initializeFiltersFromUrl(location, defaultFilters, defaultAdvancedFilters) : {
    filters: defaultFilters,
    advancedFilters: defaultAdvancedFilters,
    customStart: '',
    customEnd: ''
  };

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
    const [filteredConversations, setFilteredConversations] = useState([]);
    const [email, setEmail] = useState(null)
    const [client_id, setClient_id] = useState(null)
    const [service_id, setService_id] = useState(null)
    const [totalRecords, setTotalRecords] = useState(0)
    const [originalSize, setOriginalSize] = useState(0)
    const [openType, setOpenType] = useState(null)
    const [showCustomerPage, setShowCustomerPage] = useState(false);
    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const [filterMode, setFilterMode] = useState('quick');
    const [customerIds, setCustomerIds] = useState([]);
    const [selectedCustomerID, setSelectedCustomerID] = useState(null)
    const [segmentParameterData, setSegmentParameterData] = useState({'type':null, 'id': null, 'name': null})
    const [role] = useState(()=> {
      const userCookie = getCookie('dashboard_login_user_creds');
      if (userCookie) {
        const userData = JSON.parse(userCookie);
        const role = userData.role
        return role
      }
      return 'admin';
    })
    const [expandedSections, setExpandedSections] = useState({
      businessInsights: false,
      concernsAndQueries: false,
      dispositionAndSubdisposition: false
    });
    const [filters, setFilters] = useState(initialFilterState.filters);
    const [advancedFilters, setAdvancedFilters] = useState(initialFilterState.advancedFilters);
      const [page, setPage] = useState(() => (!segment && !type ? getListPageFromLocation(location, 'custPage') : 1));
      const [totalPages, setTotalPages] = useState(1);
      const [apiCallRunning, setApiCallRunning] = useState(false)
      const [loading, setLoading] = useState(false)
      // Ref for aborting customer page requests
      const customerAbortRef = useRef(null);
      const [dummyFilterData, setDummyFilterData] = useState({
        agents: [],
        modes: ['Call', 'Email', 'Chat'],
        firstinteraction: ['Today',
          'Yesterday',
          'This Week',
          "This Month",
          "Last Month",
          "Last 7 Days",
          "Last 30 Days",
          "Last 3 Months",
          "Custom Range"],
        lastinteraction: ['Today',
          'Yesterday',
          'This Week',
          "This Month",
          "Last Month",
          "Last 7 Days",
          "Last 30 Days",
          "Last 3 Months",
          "Custom Range"]
      });
      let [dummyAdvancedFilterData, setDummyAdvancedFilterData] =useState({
        refusal_category: [],
        open_concerns_and_queries: ['Yes', 'No'],
        customer_outcome: [],
        customer_potential: [],
        business_insight_parameters: [],
        concern_categories: [],
        concern_subcategories: [],
        query_categories: [],
        query_subcategories: [],
        disposition: [],
        subdisposition: [],
        lead_sources: [],
        tags: []
      })
      const [conversations, setConversations] = useState([]);
      
      // Update URL whenever filters change (only if not using segment prop)
      useEffect(() => {
        if (!segment && !type && client_id && service_id) { // Only update URL for standalone usage, not when embedded as modal
          // Debounce URL updates to avoid conflicts with navigation
          const timeoutId = setTimeout(() => {
            updateUrlWithFilters(navigate, location, filters, advancedFilters, '', '', page, { pageParam: 'custPage' });
          }, 300);
          
          return () => clearTimeout(timeoutId);
        }
      }, [filters, advancedFilters, segment, type, client_id, service_id, page]); // Removed navigate and location from deps

      useEffect(() => {
        if (segment || type) return;
        const fromUrl = getListPageFromLocation(location, 'custPage');
        setPage((p) => (p !== fromUrl ? fromUrl : p));
      }, [location.search, segment, type]);

      function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    const mapBusinessInsightsForDownload = (list) => {
      if (!Array.isArray(list)) return [];
      return list.map((item) => {
        if (item?.business_insights_parameter != null) return item;
        if (item && item.business_insights_parameter == null && 'business_insight_key' in item) {
          return {
            business_insights_parameter: item.business_insight_key,
            business_insights_parameter_value: item.business_insight_value
          };
        }
        return item;
      });
    };

    const downloadCustomers = async (parametersJson, downloadFilterMode, parsedIds = []) => {
      showToast("We're preparing your download. You'll receive an email with the link shortly.", "success");
      let parametersList = [];
      try {
        const parsed = JSON.parse(parametersJson);
        if (Array.isArray(parsed)) parametersList = parsed;
      } catch {
        parametersList = [];
      }
      const body = buildVoiceAgentCustomersDownloadBody({
        clientId: client_id,
        serviceId: service_id,
        email,
        parametersList,
        filterType: downloadFilterMode,
        customerIds: Array.isArray(parsedIds) ? parsedIds : [],
        totalRecords,
        filters,
        advancedFilters,
        segmentParameterData,
        mapBusinessInsights: mapBusinessInsightsForDownload
      });
      try {
        const res = await server.postVoiceAgentCustomersDownloadRequest(body);
        if (!res.ok) {
          showToast('Could not queue your download. Please try again later', 'error');
        }
      } catch (error) {
        showToast('Something went wrong. Please try again later', 'error');
      }
    };

    const captureRecords = async (payload) => {
      setIsDownloadModalOpen(false);
      const { parametersJson, filterMode: dlMode, parsedIds } = payload;
      await downloadCustomers(parametersJson, dlMode, parsedIds);
    };

    const handleQuickFilterChange = (e, key) => {
      const value = e.target.value;
      
      // If changing time filter and it's not "Custom Range", clear the custom date values
      if ((key === 'firstinteraction' || key === 'lastinteraction') && value !== 'Custom Range') {
        setFilters((prev) => ({ 
          ...prev, 
          [key]: value,
          'First Interaction Start': '',
          'First Interaction End': '',
          'Last Interaction Start': '',
          'Last Interaction End': ''
        }));
      } else {
        setFilters((prev) => ({ ...prev, [key]: value }));
      }
    };
      const handleAdvancedInputChange = (e, key) => {
        const value = e.target.value;
        setAdvancedFilters((prev) => ({
          ...prev,
          [key]: value,
        }));
      };
    
    const formatEpochToReadableDate = (epoch) => {
        const date = new Date(epoch*1000); // Convert seconds to milliseconds
        const options = { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
        return date.toLocaleString('en-GB', options).replace(',', '');
      };
    const toggleAdvancedFilterPanel = () => {
        setShowAdvancedFilters(!showAdvancedFilters);
    };
    
    const get_customer_page_details = async (client_id, service_id, page_size) => {
      // abort previous
      if(customerAbortRef.current){ customerAbortRef.current.abort(); }
      const controller = new AbortController();
      customerAbortRef.current = controller;

      try {
        setApiCallRunning(true);
        setLoading(true);

        const res = await server.get_voice_agent_customers_list(client_id, service_id, email, 'customers', undefined, page_size, filters.customer_id, filters.agent, filters.firstinteraction, filters.lastinteraction, filters['First Interaction Start'], filters['First Interaction End'], filters['Last Interaction Start'], filters['Last Interaction End']);
        if(res.status === 200){
          const resp = await res.json();
          setConversations(resp.data);
          setFilteredConversations(resp.data);
          const totalRecords = resp.total_records;
          setTotalRecords(totalRecords);
          setOriginalSize(totalRecords);
          setTotalPages(Math.ceil(totalRecords / 50));
          setLoading(false);
        }else{
          showToast('Something went wrong. Please try again later', 'error')
          setApiCallRunning(false)
          setLoading(false)
        }
        setApiCallRunning(false);
      }catch(error){
        if(error.name === 'AbortError'){
          setApiCallRunning(false);
          return;
        }
        setApiCallRunning(false);
        setLoading(false);
      }
    }

  // fetch filter details once
  const fetchFilterDetailsOnceCustomers = async () => {
    try{
      const res = await server.getVoiceAgentsMetricsFilters(client_id, service_id, email, 'customers', undefined);
      if(res.status === 200){
        const data = await res.json();
        setDummyFilterData(prev=>({...prev, agents: data.agents}));
        setDummyAdvancedFilterData(prev=>({
          ...prev,
          customer_outcome: data.customer_outcome,
          refusal_category: data.refusal_category,
          customer_potential: data.customer_potential,
          business_insight_parameters: data.business_insights,
          concern_categories: data.concerns_category,
          concern_subcategories: data.concerns_subcategory,
          query_categories: data.query_category,
          query_subcategories: data.query_subcategory,
          disposition: data.disposition,
          subdisposition: data.subdisposition,
          lead_sources: data.lead_sources,
          tags: data.tags
        }));
      }
    }catch(err){}
  }
  // Function to get disposition keys (for the disposition dropdown)
  const getDispositionKeys = () => {
    if (!dummyAdvancedFilterData.subdisposition || typeof dummyAdvancedFilterData.subdisposition !== 'object') {
      return dummyAdvancedFilterData.disposition || [];
    }
    const keys = Object.keys(dummyAdvancedFilterData.subdisposition);
    return keys;
  };

  const getSubdispositionsForDisposition = (selectedDisposition) => {
    if (!dummyAdvancedFilterData.subdisposition) {
      return [];
    }
    
    // If no disposition selected, return all subdispositions
    if (!selectedDisposition) {
      if (typeof dummyAdvancedFilterData.subdisposition === 'object' && !Array.isArray(dummyAdvancedFilterData.subdisposition)) {
        // Flatten all subdispositions from all dispositions
        return Object.values(dummyAdvancedFilterData.subdisposition).flat();
      }
      return dummyAdvancedFilterData.subdisposition || [];
    }
    
    if (typeof dummyAdvancedFilterData.subdisposition === 'object' && !Array.isArray(dummyAdvancedFilterData.subdisposition)) {
      const subdispositions = dummyAdvancedFilterData.subdisposition[selectedDisposition] || [];
      return subdispositions;
    }
    
    return dummyAdvancedFilterData.subdisposition || [];
  };

  // Enhanced handler for disposition changes
  const handleDispositionChange = (e) => {
    const newDisposition = e.target.value;
    
    setAdvancedFilters(prev => ({
      ...prev,
      disposition: newDisposition
    }));
    
    if (newDisposition) {
      const validSubdispositions = getSubdispositionsForDisposition(newDisposition);
      const currentSubdisposition = advancedFilters.subdisposition;
      
      // If current subdisposition is not valid for new disposition, clear it
      if (currentSubdisposition && !validSubdispositions.includes(currentSubdisposition)) {
        setAdvancedFilters(prev => ({
          ...prev,
          subdisposition: ''
        }));
      }
    } else {
      setAdvancedFilters(prev => ({
        ...prev,
        subdisposition: ''
      }));
    }
  };
  // Function to get concern category keys (for the concern category dropdown)
  const getConcernCategoryKeys = () => {
    if (!dummyAdvancedFilterData.concern_subcategories || typeof dummyAdvancedFilterData.concern_subcategories !== 'object') {
      return dummyAdvancedFilterData.concern_categories || [];
    }
    const keys = Object.keys(dummyAdvancedFilterData.concern_subcategories);
    return keys;
  };

  const getConcernSubcategoriesForCategory = (selectedConcernCategory) => {
    if (!dummyAdvancedFilterData.concern_subcategories) {
      return [];
    }
    
    // If no concern category selected, return all subcategories
    if (!selectedConcernCategory) {
      if (typeof dummyAdvancedFilterData.concern_subcategories === 'object' && !Array.isArray(dummyAdvancedFilterData.concern_subcategories)) {
        // Flatten all subcategories from all categories
        return Object.values(dummyAdvancedFilterData.concern_subcategories).flat();
      }
      return dummyAdvancedFilterData.concern_subcategories || [];
    }
    
    if (typeof dummyAdvancedFilterData.concern_subcategories === 'object' && !Array.isArray(dummyAdvancedFilterData.concern_subcategories)) {
      const subcategories = dummyAdvancedFilterData.concern_subcategories[selectedConcernCategory] || [];
      return subcategories;
    }
    
    return dummyAdvancedFilterData.concern_subcategories || [];
  };

  // Enhanced handler for concern category changes
  const handleConcernCategoryChange = (e) => {
    const newConcernCategory = e.target.value;
    
    setAdvancedFilters(prev => ({
      ...prev,
      concernCategory: newConcernCategory
    }));
    
    if (newConcernCategory) {
      const validSubcategories = getConcernSubcategoriesForCategory(newConcernCategory);
      const currentSubcategory = advancedFilters.concernSubcategory;
      
      // If current subcategory is not valid for new category, clear it
      if (currentSubcategory && !validSubcategories.includes(currentSubcategory)) {
        setAdvancedFilters(prev => ({
          ...prev,
          concernSubcategory: ''
        }));
      }
    } else {
      setAdvancedFilters(prev => ({
        ...prev,
        concernSubcategory: ''
      }));
    }
  };

  // Function to get query category keys (for the query category dropdown)
  const getQueryCategoryKeys = () => {
    if (!dummyAdvancedFilterData.query_subcategories || typeof dummyAdvancedFilterData.query_subcategories !== 'object') {
      return dummyAdvancedFilterData.query_categories || [];
    }
    const keys = Object.keys(dummyAdvancedFilterData.query_subcategories);
    return keys;
  };

  const getQuerySubcategoriesForCategory = (selectedQueryCategory) => {
    if (!dummyAdvancedFilterData.query_subcategories) {
      return [];
    }
    
    // If no query category selected, return all subcategories
    if (!selectedQueryCategory) {
      if (typeof dummyAdvancedFilterData.query_subcategories === 'object' && !Array.isArray(dummyAdvancedFilterData.query_subcategories)) {
        // Flatten all subcategories from all categories
        return Object.values(dummyAdvancedFilterData.query_subcategories).flat();
      }
      return dummyAdvancedFilterData.query_subcategories || [];
    }
    
    if (typeof dummyAdvancedFilterData.query_subcategories === 'object' && !Array.isArray(dummyAdvancedFilterData.query_subcategories)) {
      const subcategories = dummyAdvancedFilterData.query_subcategories[selectedQueryCategory] || [];
      return subcategories;
    }
    
    return dummyAdvancedFilterData.query_subcategories || [];
  };

  // Enhanced handler for query category changes
  const handleQueryCategoryChange = (e) => {
    const newQueryCategory = e.target.value;
    
    setAdvancedFilters(prev => ({
      ...prev,
      queryCategory: newQueryCategory
    }));
    
    if (newQueryCategory) {
      const validSubcategories = getQuerySubcategoriesForCategory(newQueryCategory);
      const currentSubcategory = advancedFilters.querySubcategory;
      
      // If current subcategory is not valid for new category, clear it
      if (currentSubcategory && !validSubcategories.includes(currentSubcategory)) {
        setAdvancedFilters(prev => ({
          ...prev,
          querySubcategory: ''
        }));
      }
    } else {
      setAdvancedFilters(prev => ({
        ...prev,
        querySubcategory: ''
      }));
    }
  };

  useEffect(()=>{
    if(client_id && service_id && email){
      fetchFilterDetailsOnceCustomers();
    }
  }, [client_id, service_id, email]);
    
      const handleNextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
      };
    
      const handlePreviousPage = () => {
          if (page > 1) {
              setPage(page - 1);
          }
      };
      const updateBusinessInsights = (index, field, value) => {
        setAdvancedFilters((prev) => ({
          ...prev,
          business_insights_multiple: prev.business_insights_multiple.map((item, i) => i === index ? { ...item, [field]: value } : item)
        }));
      };
      const isInitializingRef = useRef(false); // to prevent API calls during initialization
    
      useEffect(()=> {
        isInitializingRef.current = true;
        const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
          if (user) {
            setEmail(user.email);
          }
          if(serviceID){
            setService_id(serviceID)
          }
          if(clientID){
            setClient_id(clientID)
          }
          if(type){
            setOpenType(type)
          }
          if(segment){
            setSegmentParameterData(segment)
            if(segment.filter_applied?.time || segment.filter_applied?.lastinteraction){
              const lastInteractionValue = segment.filter_applied?.lastinteraction ?? segment.filter_applied?.time;
              handleQuickFilterChange({ 'target': { 'value': lastInteractionValue } }, 'lastinteraction')
              
              if(lastInteractionValue === 'Custom Range'){
                setFilters((prev) => ({ ...prev, ['Last Interaction Start']: segment.filter_applied['Last Interaction Start'] || '' }));
                setFilters((prev) => ({ ...prev, ['Last Interaction End']: segment.filter_applied['Last Interaction End'] || '' }));
              }
            }
            // Map employee -> agent when coming from Business Insights
            if(segment.filter_applied?.employee && !segment.filter_applied?.agent){
              handleQuickFilterChange({ 'target': { 'value': segment.filter_applied.employee } }, 'agent')
            }
            if(segment.filter_applied?.agent){
              handleQuickFilterChange({'target': {'value': segment.filter_applied.agent}}, 'agent')
            }
            if(segment.filter_applied?.firstinteraction){
              handleQuickFilterChange({'target': {'value': segment.filter_applied.firstinteraction}}, 'firstinteraction')
              if(segment.id && segment.name){ 
                setFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
              if(segment.filter_applied?.firstinteraction === 'Custom Range'){
                setFilters((prev) => ({ ...prev, ['First Interaction Start']: segment.filter_applied['First Interaction Start'] }));
                setFilters((prev) => ({ ...prev, ['First Interaction End']: segment.filter_applied['First Interaction End'] }));
              }
            }
            if(segment.filter_applied?.id){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.id}}, 'id')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.customerPotential){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.customerPotential}}, 'customerPotential')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.interactions){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.interactions}}, 'interactions')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.openConcerns){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.openConcerns}}, 'openConcerns')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.customer_outcome){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.customer_outcome}}, 'customer_outcome')
              // setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.businessInsightParameter && segment.filter_applied?.businessInsightValue){
              setAdvancedFilters((prev) => ({ ...prev, business_insights_multiple: [{'business_insights_parameter': segment.filter_applied.businessInsightParameter, 'business_insights_parameter_value': segment.filter_applied.businessInsightValue}] }));
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.business_insights_multiple){
              setAdvancedFilters((prev) => ({ ...prev, business_insights_multiple: segment.filter_applied.business_insights_multiple }));
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.concernCategory){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.concernCategory}}, 'concernCategory')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.concernSubcategory){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.concernSubcategory}}, 'concernSubcategory')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.queryCategory){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.queryCategory}}, 'queryCategory')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.querySubcategory){ 
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.querySubcategory}}, 'querySubcategory')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.disposition){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.disposition}}, 'disposition')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.subdisposition){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.subdisposition}}, 'subdisposition')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.lead_source){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.lead_source}}, 'lead_source')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
            if(segment.filter_applied?.tag){
              handleAdvancedInputChange({'target': {'value': segment.filter_applied.tag}}, 'tag')
              if(segment.id && segment.name){ 
                setAdvancedFilters((prev) => ({ ...prev, [segment.id]: segment.name ? segment.name : "Yes" }));
              }
            }
          }
          if(role === 'agent'){
            handleQuickFilterChange({'target': {'value': user.name}}, 'agent')
          }
          const initTimeout = setTimeout(() => {
            isInitializingRef.current = false;
          }, 100);
          
          return () => {
            clearTimeout(initTimeout);
          };
      }, [serviceID, clientID, segment, role])

      // Handle page navigation
      useEffect(() => {
          if(client_id && service_id){
            get_customer_page_details(client_id, service_id, page);
          }
        }, [client_id, service_id, page]);
        const filtersDebounceRef = useRef(null);
        const firstFiltersLoadRef = useRef(true);
        useEffect(() => {
          if (!client_id || !service_id) return;
      
          // Skip debounce logic on initial mount to avoid duplicate first fetch
          if (firstFiltersLoadRef.current) {
            firstFiltersLoadRef.current = false;
            return;
          }
          if (isInitializingRef.current) {
            return;
          }
      
          // Clear previous debounce timer
          if (filtersDebounceRef.current) {
            clearTimeout(filtersDebounceRef.current);
          }
      
          filtersDebounceRef.current = setTimeout(() => {
            // Only reset to first page; page effect will handle fetching once
            if (page !== 1) {
              setPage(1);
            } else {
                get_customer_page_details(client_id, service_id, 1);
            }
          }, 600); // idle delay
      
          return () => {
            if (filtersDebounceRef.current) {
              clearTimeout(filtersDebounceRef.current);
            }
          };
        }, [filters, advancedFilters, client_id, service_id]);

        const handleCustomerPage = (id) => {
          if (openType === 'modal-open'){
            setSelectedCustomerID(id)
            setShowCustomerPage(true);
            return;
          }
          if (!segment && !type && client_id && service_id) {
            updateUrlWithFilters(navigate, location, filters, advancedFilters, '', '', page, { pageParam: 'custPage' });
          }
          // Properly encode the customer ID to handle special characters, spaces, and other URL-unsafe characters
          const encodedCustomerId = encodeURIComponent(id);
          navigateWithCurrentQuery(navigate, location, `/voice-agents/${client_id}/${service_id}/customers/${encodedCustomerId}`)
        }
        const handleClose = (e) => {
          setShowCustomerPage(false);
        }
        const getBusinessInsightValues = (selectedParameter) => {
          if (!selectedParameter || !dummyAdvancedFilterData.business_insight_parameters) return [];
          
          // If business_insights_parameters is an object with key-value pairs
          if (typeof dummyAdvancedFilterData.business_insight_parameters === 'object' && !Array.isArray(dummyAdvancedFilterData.business_insight_parameters)) {
            // Convert display name back to key format
            const keyFormat = selectedParameter.toLowerCase().replace(/ /g, '_');
            return dummyAdvancedFilterData.business_insight_parameters[keyFormat] || [];
          }
          
          // If business_insights_parameters is an array of arrays like [['key', ['values']], ...]
          if (Array.isArray(dummyAdvancedFilterData.business_insight_parameters)) {
            const selectedInsight = dummyAdvancedFilterData.business_insight_parameters.find(
              ([key]) => key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) === selectedParameter
            );
            return selectedInsight ? selectedInsight[1] : [];
          }
          
          return [];
        };
      
        // Get business insight parameter keys (formatted for display)
        const getBusinessInsightKeys = () => {
          if (!dummyAdvancedFilterData.business_insight_parameters) return [];
          
          // If it's an object, get the keys
          if (typeof dummyAdvancedFilterData.business_insight_parameters === 'object' && !Array.isArray(dummyAdvancedFilterData.business_insight_parameters)) {
            return Object.keys(dummyAdvancedFilterData.business_insight_parameters).map(key => 
              key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
            );
          }
          
          // If it's an array of arrays, get the first element of each sub-array
          if (Array.isArray(dummyAdvancedFilterData.business_insight_parameters)) {
            return dummyAdvancedFilterData.business_insight_parameters.map(([key]) => 
              key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
            );
          }
          
          return [];
        };
        useEffect(() => {
          const handleEsc = (event) => {
            if (event.key === "Escape") {
              setShowAdvancedFilters(false);
            }
          }
          if (showAdvancedFilters) {
            window.addEventListener('keydown', handleEsc);
          }
          return () => {
            window.removeEventListener('keydown', handleEsc);
          }
        }, [showAdvancedFilters])
    
    return (
        <div className="flex flex-col font-sans bg-white" style={{height: "100%"}}>
          {!showCustomerPage && <main className="flex-1 py-3 px-5 bg-gray-50">
            <div className="mb-4">
                <h1 className="text-xl font-semibold text-gray-900 mb-2">Customer Records</h1>
                <p className="text-sm text-gray-500">View and manage all customer information and interactions</p>
            </div>

            {/* Active Filters */}
            {advancedFilters.length > 0 && (
                <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
                <div className="flex flex-wrap gap-2">
                    {advancedFilters.map((filter, index) => (
                    <div key={index} className="flex items-center bg-gray-100 rounded-full px-3 py-1 text-sm">
                        <span className="mr-1">{filter.type}:</span>
                        <span className="font-medium">{filter.value}</span>
                        <button 
                        className="ml-2 text-gray-500 hover:text-gray-700"
                        >
                        <FaClose className="h-3 w-3" />
                        </button>
                    </div>
                    ))}
                    {advancedFilters.length > 0 && (
                    <button 
                        className="text-sm text-blue-600 hover:text-blue-800"
                        onClick={() => setAdvancedFilters([])}
                    >
                        Clear all
                    </button>
                    )}
                </div>
                </div>
            )}

            {/* Primary Filter Section */}
            <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
                <div className="flex justify-between items-center mb-4">
                <div className="text-sm font-medium text-gray-700">Quick Filters</div>
                <div className="flex space-x-3">
                <button
                  onClick={() => setIsDownloadModalOpen(true)}
                  className="flex items-center px-4 py-2 rounded text-sm text-white hover:opacity-90"
                  style={{ backgroundColor: "rgb(79, 70, 229)" }}
                >
                  <Download className="h-4 w-4 mr-2" />
                  Download
                </button>
                <button 
                    onClick={toggleAdvancedFilterPanel}
                    className="flex items-center text-sm text-indigo-600 hover:text-indigo-800"
                >
                    <FaFilter className="h-4 w-4 mr-1" />
                    Show Advanced Filters
                </button>
                </div>
                </div>
                <div className="grid grid-cols-5 gap-4">
              
                    <input class="global-input"value={filters.customer_id} type="text" placeholder="Customer ID" onChange={(e) => handleQuickFilterChange(e, 'customer_id')} 
                    className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input" />
                
                <ModernTimeDropdown isDisabled={role === 'agent'} placeholder="Agent" value={filters.agent} onChange={(e) => handleQuickFilterChange(e, 'agent')} options={dummyFilterData.agents}/>
                <ModernTimeDropdown placeholder="First Interaction Time" value={filters.firstinteraction} onChange={(e) => handleQuickFilterChange(e, 'firstinteraction')} options={dummyFilterData.firstinteraction}/>
                <ModernTimeDropdown placeholder="Last Interaction Time" value={filters.lastinteraction} onChange={(e) => handleQuickFilterChange(e, 'lastinteraction')} options={dummyFilterData.lastinteraction}/>
                </div>
                <div>
                {filters.lastinteraction === "Custom Range" && (
                      <div className="flex gap-4 mb-2">
                        <div>
                          <ModernDatePicker
                            placeholder="Start Date"
                            value={filters['Last Interaction Start']}
                            onChange={(e)=>handleQuickFilterChange(e, 'Last Interaction Start')}
                            minDate={filters['Last Interaction End'] ? new Date(new Date(filters['Last Interaction End']).getTime() - 90*24*60*60*1000) : undefined}
                            maxDate={filters['Last Interaction End'] || undefined}
                          />
                        </div>
                        <div>
                        <ModernDatePicker
                          placeholder="End Date"
                          value={filters['Last Interaction End']}
                          onChange={(e)=>handleQuickFilterChange(e, 'Last Interaction End')}
                          minDate={filters['Last Interaction Start'] || undefined}
                          maxDate={filters['Last Interaction Start'] ? new Date(new Date(filters['Last Interaction Start']).getTime() + 90*24*60*60*1000) : undefined}
                        />
                        </div>
                      </div>
                    )}
                    {filters.firstinteraction === "Custom Range" && (
                      <div className="flex gap-4 mb-2">
                        <div>
                          <ModernDatePicker
                            placeholder="Start Date"
                            value={filters['First Interaction Start']}
                            onChange={(e)=>handleQuickFilterChange(e, 'First Interaction Start')}
                            minDate={filters['First Interaction End'] ? new Date(new Date(filters['First Interaction End']).getTime() - 90*24*60*60*1000) : undefined}
                            maxDate={filters['First Interaction End'] || undefined}
                          />
                        </div>
                        <div>
                        <ModernDatePicker
                          placeholder="End Date"
                          value={filters['First Interaction End']}
                          onChange={(e)=>handleQuickFilterChange(e, 'First Interaction End')}
                          minDate={filters['First Interaction Start'] || undefined}
                          maxDate={filters['First Interaction Start'] ? new Date(new Date(filters['First Interaction Start']).getTime() + 90*24*60*60*1000) : undefined}
                        />
                        </div>
                      </div>
                    )}
                </div>
                {/* Filter Display */}
                <div className="flex gap-4 mb-4 mt-4 flex-wrap">
                    {Object.keys(filters).map(
                      (key) => {
                        if ((key === 'First Interaction Start' || key === 'First Interaction End') && filters.firstinteraction !== 'Custom Range' || (key === 'Last Interaction Start' || key === 'Last Interaction End') && filters.lastinteraction !== 'Custom Range') {
                          return null;
                        }
                        return filters[key] && (
                          <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                            <span className="capitalize text-indigo-600">{key} - {filters[key]}</span>
                            {(key!=='lastinteraction' && key !== segmentParameterData.id && !(role === 'employee' && key === 'employee')) && <button
                              className="ml-2 text-gray-600"
                              onClick={() => setFilters((prev) => ({ ...prev, [key]: '' }))}
                            >
                              <FaTimes />
                            </button>}
                          </div>
                        )
                      })}
                      {/* Show advanced filters that are set (excluding defaults) */}
                      {Object.entries(advancedFilters).map(([key, val]) => {
                        // skip if blank or default
                        if (
                          val === ''
                        ) {
                          return null;
                        }
                        if(key === 'business_insights_multiple' && val.filter((item)=>item.business_insights_parameter_value!=null).length > 0){
                          return (
                            <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                              <span className="capitalize text-indigo-600">Business Insights - {val.filter((item)=>item.business_insights_parameter_value!=null).map((item)=>item.business_insights_parameter).join(', ')}</span>
                            </div>
                          )
                        }
                        if(key !== 'business_insights_multiple'){
                        return (
                          <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                            <span className="capitalize text-indigo-600">{key} - {String(val)}</span>
                            <button
                              className="ml-2 text-gray-600"
                              onClick={() => setAdvancedFilters((prev) => ({ ...prev, [key]: '' }))}
                            >
                              <FaTimes />
                            </button>
                          </div>
                        );
                      }
                      })}
                    </div>
            </div>

            {/* Advanced Filter Panel (appears from the right) */}
            {showAdvancedFilters && (
              <div className={`fixed top-0 right-0 h-full bg-white border-l shadow-lg w-96 transition-transform duration-300 transform ${showAdvancedFilters ? 'translate-x-0' : 'translate-x-full'}`} style={{zIndex: "99999999999999"}}>
              <div className='bg-gray-50' style={{padding: "20px 24px",display: "flex",alignItems: "center",justifyContent: "space-between", borderBottom: "1px solid #00000012", height: "4rem"}}>
                <h2 className="text-lg font-medium mb-0 text-xl font-semibold text-gray-900">Advanced Filters</h2>
                <button onClick={toggleAdvancedFilterPanel}>
                  <FaTimes />
                </button>
              </div>
                <div style={{overflowY: "auto", height: "calc(100vh - 4rem)"}}>
                <div className="space-y-4" style={{padding: "15px 0", paddingRight: "20px", paddingLeft: "1.5rem"}}>
                    
                    <div>
                    <label className="block text-sm font-medium mb-2">Number of Interactions</label>
                    <ModernTimeDropdown width='w-full' placeholder="Select Number" value={advancedFilters.interactions} onChange={(e) => handleAdvancedInputChange(e, 'interactions')} options={['1', '2-3', '4-5', 'More than 5']}/>
                    </div>
                </div>
                </div>
                </div>
            )}

            <VoiceCustomerDownloadParametersModal
              filterMode={filterMode}
              setFilterMode={setFilterMode}
              setCustomerIds={setCustomerIds}
              isOpen={isDownloadModalOpen}
              onClose={() => setIsDownloadModalOpen(false)}
              quickFilterApproxCount={totalRecords}
              onApply={captureRecords}
            />

            {/* Table */}
            <div className="bg-white rounded-lg shadow-sm" style={{height: "52vh", overflowY: "auto"}}>
                {
                    loading ? (
                        <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                            <div className="loader"></div>
                            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                        </div>
                    ) : (
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead style={{ position: "sticky", top: "0" }}>
                                <tr>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Customer ID</th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Agent ID</th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>First Interaction Time</th>
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Last interaction Time</th>
                                {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Customer outcome</th> */}
                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{background: "white", fontSize: "13px"}}>Action</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {filteredConversations.map((customer) => (
                                <tr key={customer.customer_id} className="hover:bg-gray-50">
                                    <td className="px-5 py-3 whitespace-nowrap text-sm text-blue-600" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{customer.customer_id}</td>
                                    <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-900" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{customer.agent_id}</td>
                                    <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-500" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{formatEpochToReadableDate(customer.first_interaction_time)}</td>
                                    <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-500" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{formatEpochToReadableDate(customer.last_interaction_time)}</td>
                                    {/* <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-900" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                                    {customer.outcome}
                                    </td> */}
                                    <td onClick={()=>handleCustomerPage(customer.customer_id)} className="px-5 py-3 whitespace-nowrap text-sm text-blue-600" style={{fontSize: "0.7rem", lineHeight: "1rem", cursor: "pointer"}}>View Details</td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                }
            </div>
            {/* Pagination */}
            <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
              <div className="flex-1 flex justify-between sm:hidden">
                <div onClick={handlePreviousPage} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                  Previous
                </div>
                <div onClick={handleNextPage} className="ml-3 inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                  Next
                </div>
              </div>
              <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{(50*(page-1))+1}</span> to <span className="font-medium">{totalRecords <= 50 ? totalRecords : 50*page}</span> of <span className="font-medium">{totalRecords}</span> records
                  </p>
                </div>
                <div>
                  <nav className="z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    <div onClick={handlePreviousPage} className="inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" style={{cursor: "pointer"}}>
                      Previous
                    </div>
                    <div onClick={handleNextPage} className="inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" style={{cursor: "pointer"}}>
                      Next
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            </main>}
            {
          showCustomerPage && (
            <CustomerDetails selectedOption={service_id} open_type={handleClose} customerIdProp={selectedCustomerID} selectedClientId={client_id}/>
          )
        }
        <style jsx>
            {`
            .sections-headings {
                            cursor: pointer;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 15px;
                            border-radius: 10px;
                            transition: background 0.3s;
                            width: 100%;
                            }

                            .section-title {
                            font-size: 15px;
                            font-weight: 500;
                            display: flex;
                            align-items: center;
                            }
            `}              
          </style>
        </div>
    )
}

export default CustomerRecords